
class PresetConfigController {

	constructor($scope, $element) {
		this.scope = $scope;
		this.el = $element;

		this.scope.$on('PresetConfigController:setPreset', this.loadPresetConfig.bind(this));

		this.isOnSubmit = false;
	}

	loadPresetConfig(e, preset) {
		this.isOnSubmit = false;
		this.presetConfig = Object.assign({}, preset.state.style);
		if(this.presetConfig.presetTitleFontSize === undefined){
			this.resetPresetFontSize();
		}
		if(this.presetConfig.widgetTitleFontSize === undefined){
			this.resetWidgetFontSize();
		}
	}

	savePresetSetting() {
		this.isOnSubmit = true;

		if(this.frmPresetConfig.$valid) {
			this.scope.$emit('DashboardContainerController:onPresetConfigChanged', this.presetConfig);
			this.el[0].hideDialog();
			this.isOnSubmit = false;
		}
	}

	resetPresetFontSize(){
		this.presetConfig.presetTitleFontSize = 20;
	}

	resetWidgetFontSize(){
		this.presetConfig.widgetTitleFontSize = 14;
	}
}

export default PresetConfigController;


// WEBPACK FOOTER //
// ./resources/WEB-INF/package/system/dashboard/PresetConfigController.js